import http from '@/base/api/public'
import querystring from 'querystring'

let apiUrl = require('@/../config/sysConfig')
// 検索
export const k_0007 = (params) => {
  //params序列化
  let querys = querystring.stringify(params)
  return http.requestGet(apiUrl.apiUrl_AttendExpenseAttendancesExpense + '?' + querys)
}
// 更新
export const k_0007_update = (params) => {
  return http.requestPut(apiUrl.apiUrl_AttendExpenseAttendances, params)
}

//图片更新
export const k_0007_saveImage = (formData) => {
  let querys = querystring.stringify(formData)
  return http.requestPostFormData(apiUrl.apiUrl_filesUpdate, formData)
}

// マスタデータ
export const conditionApi = (page, div) => {
  console.log('apiUrl.apiurl_masterData:' + apiUrl.apiurl_masterData)
  return http.requestQuickGet(apiUrl.apiurl_masterData + '/' + page + '/' + div)
}
// 店舗現場情報
export const storeFieldInfo = (params) => {
  let querys = querystring.stringify(params)
  return http.requestGet(apiUrl.apiUrl_storeFieldInfo + '?' + querys)
}
// 写真情報取得
export const photoInfo = (params) => {
  let querys = querystring.stringify(params)
  return http.requestGet(apiUrl.apiUrl_AttendPhotoInfo + '?' + querys)
}

//图片查询
export const photoFile_get = (params) => {
  return http.requestQuickGetImage(apiUrl.apiUrl_FilesSearch + '?filePath=' + encodeURIComponent(params.photoPath) + '&resizeCd=0')
}
//ekispert交通费查询
// export const requestEkiStationGet = (params) => {
//   let link = "/expcgi/?val_htmb=jcgi_details2&val_expressonly=0&val_airbus=3&val_max_result=10&val_preferred_ticket_order=2&val_feeling=3321122&val_shinkansen=0&val_ship=3&val_highwaybus=3&val_icticket=1&"
//   return http.requestGet(link + 'val_day=' + params.val_day + '&val_month=' + params.val_month + '&val_year=' + params.val_year + '&val_from=' + params.val_from + '&val_to=' + params.val_to)
// }
export const requestEkiStationGet = (params) => {
  let querys = querystring.stringify(params)
  return http.requestGet(apiUrl.apiUrl_expcgi + '?' + querys)
}

//google交通费查询
export const requestGoogleGet = (params) => {
  let querys = querystring.stringify(params)
  return http.requestGet(apiUrl.apiUrl_googleapis + '?' + querys)
}


// WEBPACK FOOTER //
// ./src/module/api/k_0007.js